import * as React from 'react'
import {useFela} from 'react-fela'
import {useHistory} from 'react-router'
import {Theme} from '../../../../app/theme'
import {Breadcrumb, ReaderBreadcrumbsPanel} from '../../../../commons/components/header/ReaderBreadcrumbsPanel'
import {ReaderHeaderPanel} from '../../../../commons/components/header/ReaderHeaderPanel'
import {ReaderSearchInput} from '../../../../commons/components/header/ReaderSearchInput'
import {ReaderSearchInputPanel} from '../../../../commons/components/header/ReaderSearchInputPanel'
import {ReaderSubHeaderPanel} from '../../../../commons/components/header/ReaderSubHeaderPanel'
import {
  ReaderLayoutContext,
  ReaderLayoutContextValue,
} from '../../../../commons/layouts/reader-layout/ReaderLayoutContext'
import {DigitalLogo} from '../../../../digital/components/digital-logo/DigitalLogo'
import {bookPathOverview, bookPathWebBookSlugId} from '../../../store/book.paths'

interface Props {
  bookTitle: string
  bookSlug: string
  chapterSlug: string
  userQuery?: string | null
  loading: boolean
}

export function BookWebbookSlugReaderHeaderPanel({bookSlug, chapterSlug, bookTitle, userQuery, loading}: Props) {
  const {theme} = useFela<Theme>()

  const history = useHistory()

  const {setHeaderHeight} = React.useContext<ReaderLayoutContextValue>(ReaderLayoutContext)
  React.useLayoutEffect(() => {
    const headerHeight = theme.layout.reader.headerHeight + theme.layout.reader.toolbarHeight
    setHeaderHeight(headerHeight)
  }, [setHeaderHeight, theme.layout.reader.headerHeight, theme.layout.reader.toolbarHeight])

  const logo = <DigitalLogo small />
  const breadcrumbs: Breadcrumb[] = [
    {name: 'Bücher', linkTo: bookPathOverview()},
    {name: bookTitle, linkTo: bookPathWebBookSlugId(bookSlug)},
  ]

  const searchInput = (
    <ReaderSearchInput
      onSearch={(q) => {
        history.push(bookPathWebBookSlugId(bookSlug, q))
      }}
      userQuery={userQuery || ''}
      placeholder="Dieses Buch durchsuchen"
      disabled={loading}
    />
  )

  const searchPanel = <ReaderSearchInputPanel tablet={searchInput} mobile={<div />} />

  return (
    <>
      <ReaderHeaderPanel logo={logo} search={searchPanel} />
      <ReaderSubHeaderPanel height={theme.layout.reader.toolbarHeight}>
        <ReaderBreadcrumbsPanel breadcrumbs={breadcrumbs} />
      </ReaderSubHeaderPanel>
    </>
  )
}
